export default "__VITE_ASSET__DoP6MwR7__"